import type { SagaIterator } from 'redux-saga';
import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './paymentMethodsActions';
import type { PaymentMethodProps } from './paymentMethodsTypes';

type PaymentMethodsResponse = {
  data?: PaymentMethodProps[];
};

const mkPaymentMethodsResourceConfig =
  resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<PaymentMethodProps>();

const transformResponseToResources = (response?: PaymentMethodsResponse | null): PaymentMethodProps[] | undefined =>
  response?.data?.map((paymentMethod) => ({
    ...paymentMethod,
    isDeleted: paymentMethod.deleted,
  }));

const mkResourceConfig = () =>
  mkPaymentMethodsResourceConfig({
    resourceName: 'paymentMethods',
    resourceBaseUrl: '/paymentmethods',
    axiosConfig: { headers: { 'qcs-dataset-id': null } },
    // @ts-expect-error Preserve the legacy API response as plain objects instead of changing them to Immutable Records.
    transformResponseToResources,
    successAction: actions.getPaymentMethodsSuccess,
    failureAction: actions.getPaymentMethodsFailure,
  });

export function* getPaymentMethodsActionWatcher(): SagaIterator {
  const config = mkResourceConfig();
  yield takeLeading(actions.getPaymentMethods.type, resourceSagaUtils.qcsSyncGetResources<PaymentMethodProps>, config);
}

export default [getPaymentMethodsActionWatcher];
